/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { BillingDetails } from './BillingDetails';
// @ts-ignore
import {
// @ts-ignore
    BillingDetailsFromJSON,
// @ts-ignore
    BillingDetailsFromJSONTyped,
// @ts-ignore
    BillingDetailsToJSON,
} from './BillingDetails';
// @ts-ignore
import type { PaymentMethod } from './PaymentMethod';
// @ts-ignore
import {
// @ts-ignore
    PaymentMethodFromJSON,
// @ts-ignore
    PaymentMethodFromJSONTyped,
// @ts-ignore
    PaymentMethodToJSON,
} from './PaymentMethod';
// @ts-ignore
import type { Plan } from './Plan';
// @ts-ignore
import {
// @ts-ignore
    PlanFromJSON,
// @ts-ignore
    PlanFromJSONTyped,
// @ts-ignore
    PlanToJSON,
} from './Plan';
// @ts-ignore
import type { Subscription } from './Subscription';
// @ts-ignore
import {
// @ts-ignore
    SubscriptionFromJSON,
// @ts-ignore
    SubscriptionFromJSONTyped,
// @ts-ignore
    SubscriptionToJSON,
} from './Subscription';
// @ts-ignore
import type { Trial } from './Trial';
// @ts-ignore
import {
// @ts-ignore
    TrialFromJSON,
// @ts-ignore
    TrialFromJSONTyped,
// @ts-ignore
    TrialToJSON,
} from './Trial';

/**
 * 
 * @export
 * @interface BillingInfo
 */
export interface BillingInfo {
    /**
     * 
     * @type {Plan}
     * @memberof BillingInfo
     */
    plan: Plan;
    /**
     * 
     * @type {Subscription}
     * @memberof BillingInfo
     */
    subscription: Subscription;
    /**
     * 
     * @type {Trial}
     * @memberof BillingInfo
     */
    trial: Trial;
    /**
     * 
     * @type {string}
     * @memberof BillingInfo
     */
    currencyCode: string;
    /**
     * True when billing details are inherited from another billing owner and cannot be edited in this context.
     * @type {boolean}
     * @memberof BillingInfo
     */
    billingDetailsReadOnly: boolean;
    /**
     * 
     * @type {BillingDetails}
     * @memberof BillingInfo
     */
    billingDetails?: BillingDetails;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof BillingInfo
     */
    defaultPaymentMethod?: PaymentMethod;
}

/**
 * Check if a given object implements the BillingInfo interface.
 */
// @ts-ignore
export function instanceOfBillingInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "plan" in value;
    isInstance = isInstance && "subscription" in value;
    isInstance = isInstance && "trial" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "billingDetailsReadOnly" in value;

    return isInstance;
}

// @ts-ignore
export function BillingInfoFromJSON(json: any): BillingInfo {
    return BillingInfoFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingInfo {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'plan': PlanFromJSON(json['plan']),
        'subscription': SubscriptionFromJSON(json['subscription']),
        'trial': TrialFromJSON(json['trial']),
        'currencyCode': json['currency_code'],
        'billingDetailsReadOnly': json['billing_details_read_only'],
        'billingDetails': !exists(json, 'billing_details') ? undefined : BillingDetailsFromJSON(json['billing_details']),
        'defaultPaymentMethod': !exists(json, 'default_payment_method') ? undefined : PaymentMethodFromJSON(json['default_payment_method']),
    };
}

// @ts-ignore
export function BillingInfoToJSON(value?: BillingInfo | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'plan': PlanToJSON(value.plan),
        'subscription': SubscriptionToJSON(value.subscription),
        'trial': TrialToJSON(value.trial),
        'currency_code': value.currencyCode,
        'billing_details_read_only': value.billingDetailsReadOnly,
        'billing_details': BillingDetailsToJSON(value.billingDetails),
        'default_payment_method': PaymentMethodToJSON(value.defaultPaymentMethod),
    };
}

